export default __webpack_public_path__ + "static/media/icon-demotion.862bb77c.png";